import { Wrapper } from '@components/Avatar/style'
import { GroupLabel } from '@components/Radio/style'
import { Col } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
import { Colorable, LoadingProp } from './interface'

export const Profile = styled.div<LoadingProp>`
  display: flex;
  align-items: center;
  margin-bottom: 0;

  ${({ theme, loading }) =>
    loading &&
    css`
      margin-bottom: ${theme.space.xxs};
    `}
`

export const AvatarContainer = styled.div<Colorable>`
  display: inline-block;
  margin-right: ${({ theme }) => theme.space.xs};
  svg {
    width: 16px;
  }

  ${({ theme, backgroundColor }) =>
    backgroundColor &&
    css`
      ${Wrapper} {
        background-color: ${theme.palette[backgroundColor]};
        border: none;
      }
    `}

  ${({ theme, foregroundColor }) =>
    foregroundColor &&
    css`
      ${Wrapper} {
        svg {
          color: ${theme.palette[foregroundColor]};
        }
      }
    `}
`

export const StyledCol = styled(Col)`
  padding-left: 0;
  padding-right: 0;
  margin-bottom: ${({ theme }) => theme.space.md};
`

export const PName = styled.p`
  margin: 0;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const PDate = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  color: ${({ theme }) => theme.palette.blueGray70};
`

export const Message = styled.div`
  margin-left: 46px;
  margin-top: 0;
`

export const RadioContainer = styled.div`
  ${GroupLabel} {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`

export const ErrorWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.space.lg};
  border-radius: 3px;

  &.error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .select-loader {
    display: flex;

    div:first-child {
      margin-right: ${({ theme }) => theme.space.md};
    }
  }
`

export const StyledH3Col = styled(Col)`
  padding-left: 0;
  padding-right: 0;
`
